import { useState, useEffect } from 'react';
import useCartFromAPI from '@hooks/apiLegacy/useCartFromAPI';
import useStripeInstances from '@hooks/useStripeInstances';
import useViewer from '@hooks/useViewer';

const useStripeInstanceForCart = () => {
    const [stripeInstanceForCart, setStripeInstanceForCart] = useState();
    const { viewer } = useViewer();
    const { cart } = useCartFromAPI({ viewerId: viewer?.recordId });
    const { stripeInstanceUS, stripeInstanceCA } = useStripeInstances();

    useEffect(() => {
        if (!cart || !stripeInstanceUS || !stripeInstanceCA) {
            return;
        }

        if (cart.locale === 'US') {
            setStripeInstanceForCart(stripeInstanceUS);
        } else if (cart.locale === 'CA') {
            setStripeInstanceForCart(stripeInstanceCA);
        }
    }, [cart, stripeInstanceUS, stripeInstanceCA]);

    return { stripeInstanceForCart };
};

export default useStripeInstanceForCart;
